import React from 'react';
import { useTranslation } from 'react-i18next';

import { useChatNavigation } from '~/views/alfred/use-chat-navigation/useChatNavigation';

import { ChatDeepAnalysis } from './chat-deep-analysis/ChatDeepAnalysis';
import { ChatDocumentSearch } from './chat-document-search/ChatDocumentSearch';
import { ChatQuickAnalysis } from './chat-quick-analysis/ChatQuickAnalysis';
import { ChatInputConfig } from './types';

export interface ChatInputProps {
  submitCallback?: (message?: string) => void;
  chatContext?: {
    documents?: string[];
    documentTypes?: string[];
    entityTags?: string[];
  };
  config?: ChatInputConfig;
}

export const ChatInput = ({
  submitCallback,
  chatContext,
  config,
}: ChatInputProps) => {
  useTranslation(['chat']);
  const { mode, setMode } = useChatNavigation();

  if (mode === 'document' || chatContext) {
    return (
      <ChatDocumentSearch
        config={config}
        submitCallback={submitCallback}
        chatContext={chatContext}
        mode={mode}
        setMode={setMode}
      />
    );
  }

  if (mode === 'quickAnalysis') {
    return (
      <ChatQuickAnalysis
        config={config}
        submitCallback={submitCallback}
        mode={mode}
        setMode={setMode}
      />
    );
  }

  return (
    <ChatDeepAnalysis
      config={config}
      mode={mode}
      setMode={setMode}
      submitCallback={submitCallback}
    />
  );
};
